<div class="wrapper">
  <div class="table-container">
    <input id="typeahead-format" type="text"
      [ngbTypeahead]="searchSource"
      container="body"
      placeholder="{{'Filter MISONET IOT list' | translate}}"
      class="form-control form-control-sm w-50" />

    <table class="table table-sm">
      <thead>
      <tr>
        <th scope="col" style="width: 40%;">
          {{'MISONET name' | translate}}
        </th>
        <th scope="col" style="width: 60%;">
          {{'REGO mapping' | translate}}
        </th>
      </tr>
      </thead>
      <tbody *qmLoading="loading">

      <ng-template ngFor let-link
        [ngForOf]="mappingDataMisoNetList | qmOrderBy:'deviceId' |  slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <tr>
          <td style="width: 40%;">
            <span ngbTooltip="{{link.typeId}} {{link.gatewayId?link.gatewayId:'GATEWAY'}} {{link.gatewayTypeId}}">
              {{link.deviceId}}
            </span>
          </td>
          <td style="width: 60%;">
        <span
              *ngIf="link.deviceId !== editLink; else editor;"
              class="clickable"
              [ngClass]="{
                'text-danger': !linkingListMisoNet[link.deviceId]
              }"
              (click)="setEditLink(link.deviceId);"
            >
              <ng-container *ngIf="linkingListMisoNet[link.deviceId];">
                {{getTitle(linkingListMisoNet[link.deviceId].regoId)}}
              </ng-container>
              <ng-container *ngIf="!linkingListMisoNet[link.deviceId];">
                {{'Source not linked' | translate}}
              </ng-container>
            </span>

          </td>
        </tr>
      </ng-template>
      </tbody>
    </table>
    <div style="width: 100%; margin-top: 0.2em;" class="d-flex justify-content-center">
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="10"
        [collectionSize]="total"></ngb-pagination>
    </div>

  </div>
</div>

<ng-template #editor>
  <div class="d-flex">
    <div style="flex-grow: 1;">
      <input id="typeahead-format" type="text"
             [(ngModel)]="currentLink"
             [ngbTypeahead]="search"
             [resultFormatter]="getMapObjectTitle"
             [inputFormatter]="getMapObjectTitle"
             container="body"
             class="form-control form-control-sm"
             placeholder="{{'Filter Rego map items' | translate}}" />
    </div>
    <div style="margin: 0 10px;">
      <a [attr.data-btnId]="getElementId('saveLink')" class="text-success" (click)="saveLink();">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#check"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('setEditLink')" class="text-info" (click)="setEditLink('');">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#times"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('unLink')" class="text-info" (click)="unLink()">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#trash"></use>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<i class="far fa-check" data-fa-symbol="check"></i>
<i class="far fa-times" data-fa-symbol="times"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
